module.exports = __webpack_public_path__ + "static/media/ico-sprite@2x-dd1bb3c24c.dd1bb3c2.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/stylesheets/sprites/ico-sprite@2x-dd1bb3c24c.png
// module id = 28
// module chunks = 0